import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { find, flatten, map } from 'lodash';
import Chip from 'material-ui/Chip';
import { compose } from 'recompose';
import { connect } from 'react-redux';

class SelectFieldMultiSelectWithGroups extends React.Component {
    handleChange = (event, index, value) => {
        return this.props.input.onChange(value);
    }

    formatValue = (value) => {
        const {
            optionText,
            optionValue,
            raw,
            translate,
        } = this.props;

        const choice = find(raw, { [optionValue]: value });

        if (React.isValidElement(optionText)) {
            return React.cloneElement(optionText, { record: choice });
        }

        if (typeof optionText === 'function') {
            return optionText(choice);
        }

        return translate(choice[optionText], { _: choice[optionText] });
    }

    renderItems(dataset) {
        return utils.map(dataset, (category) => {
            let renderItems = [];

            renderItems.push(<MenuItem
                disabled={ true }
                key={ category.name }
                primaryText={ category.name }
            />);

            utils.each(category.values, (subcategory) => {
                renderItems.push(this.renderMenuItem(subcategory));
            });

            return renderItems;
        });
    }

    renderMenuItem = (choice) => {
        const {
            optionValue,
        } = this.props;

        return (
            <MenuItem
                key={ choice[optionValue] }
                value={ choice[optionValue] }
                primaryText={ this.formatValue(choice[optionValue]) }
                innerDivStyle={ { padding: '0px 0 0 40px' } }
            />
        );
    }

    selectionRenderer = (values) => {
        const {
            input: {
                onChange,
            },
        } = this.props;

        return values.map((choice, _, values) => {
            return <Chip
                key={ choice }
                onRequestDelete={ (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    const index = values.indexOf(choice);

                    values.splice(index, 1);

                    onChange(values);
                } }
            >{ this.formatValue(choice) }</Chip>;
        });
    }

    render() {
        const {
            dataset,
            className,
            floatingLabelFixed = false,
            fullWidth = false,
            input,
            label,
            meta: {
                touched,
                error,
            },
            resource,
            source,
        } = this.props;

        return (
            <SelectField
                className={ className }
                dropDownMenuProps={ {
                    labelStyle: {
                        display: 'inline-flex',
                        flexWrap: 'wrap',
                        gap: '10px 5px',
                        height: 'auto',
                        minHeight: 'fit-content',
                        paddingBottom: 20,
                        paddingLeft: 0,
                    },
                } }
                errorText={ touched && error }
                floatingLabelFixed={ floatingLabelFixed }
                floatingLabelText={
                    label ? <FieldTitle label={ label } source={ source } resource={ resource } /> : false
                }
                fullWidth={ fullWidth }
                multiple={ true }
                onChange={ this.handleChange }
                selectionRenderer={ this.selectionRenderer }
                style={ {
                    height: 'fit-content',
                    minHeight: 48,
                } }
                value={ input.value }
            >
                {
                    this.renderItems(dataset)
                }
            </SelectField>
        );
    }
}

SelectFieldMultiSelectWithGroups.propTypes = {
    className: PropTypes.string,
    dataset: PropTypes.object,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    onChange: PropTypes.func,
    optionText: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.node,
    ]),
    optionValue: PropTypes.string,
    resource: PropTypes.string,
    raw: PropTypes.array,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

SelectFieldMultiSelectWithGroups.defaultProps = {
    choices: [],
    onChange: () => {
        return true;
    },
    optionText: 'name',
    optionValue: 'id',
};

const mapStateToProps = (_, props) => {
    const { dataset } = props;

    return {
        raw: flatten(map(dataset, ({ values }) => {
            return values;
        })),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
);

export default enhance(SelectFieldMultiSelectWithGroups);



// WEBPACK FOOTER //
// ./src/components/input/SelectFieldMultiSelect/SelectFieldMultiSelectWithGroups.js